import { useAuth0 } from '@auth0/auth0-react';
import { useCookies } from 'react-cookie';
import { CloudFrontCookiesKey } from '@/types';
import { useState } from 'react';

export const useAuthService = () => {
  const cookieNames = Object.values(CloudFrontCookiesKey);
  const [, , removeCookie] = useCookies(cookieNames);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const { logout, user, isAuthenticated } = useAuth0();

  const handleLogout = async () => {
    setIsLoggingOut(true);
    // Clear Cloudfront Cookies
    for (const cookieName of cookieNames) {
      removeCookie(cookieName, { path: '/', domain: '.abyssfabric.co' });
    }
    // Nothing After logout() will work, since it redirects away from this page after logout is performed.
    // auth0 logout will allways redirect to the URL specified in the returnTo parameter or just automatically go to window.location.origin
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return { handleLogout, user, isAuthenticated, isLoggingOut };
};
